import { Component, OnInit, ElementRef, Renderer, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(
    public translate: TranslateService,
    private title: Title
    ) {
      // this language will be used as a fallback when a translation isn't found in the current language
      translate.setDefaultLang('en');
      
      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use('pl');
      translate.onLangChange.subscribe((event: LangChangeEvent) => {
        // do something

      title.setTitle(environment.pageTitle);
      });
    }
    

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts